// import React, { useState } from "react";

// const WhatsAppChatbot = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const whatsappNumber = "9703933115";
//   const defaultMessage = "Hello! I want to chat.";

//   const toggleChat = () => setIsOpen(!isOpen);

//   const openWhatsApp = () => {
//     window.open(
//       `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`,
//       "_blank"
//     );
//   };

//   const buttonStyle = {
//     position: "fixed",
//     top: "50%",
//     right: "20px",
//     transform: "translateY(-50%)",
//     zIndex: 1000,
//     border: "none",
//     borderRadius: "50%",
//     padding: "15px",
//     cursor: "pointer",
//     boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
//     fontSize: "24px",
//     backgroundColor: "#25D366",
//     color: "white",
//   };

//   const chatBoxStyle = {
//     position: "fixed",
//     bottom: "80px",
//     right: "20px",
//     width: "300px",
//     maxHeight: "400px",
//     backgroundColor: "white",
//     boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
//     borderRadius: "10px",
//     overflow: "hidden",
//     display: isOpen ? "block" : "none",
//     zIndex: 999,
//     fontFamily: "Arial, sans-serif",
//   };

//   const chatHeaderStyle = {
//     backgroundColor: "#25D366",
//     color: "white",
//     padding: "10px",
//     textAlign: "center",
//     fontWeight: "bold",
//     cursor: "pointer",
//   };

//   const chatBodyStyle = {
//     padding: "10px",
//   };

//   const chatFooterStyle = {
//     display: "flex",
//     padding: "10px",
//     borderTop: "1px solid #ddd",
//   };

//   const inputStyle = {
//     flex: 1,
//     padding: "8px",
//     borderRadius: "5px",
//     border: "1px solid #ccc",
//   };

//   const sendButtonStyle = {
//     marginLeft: "5px",
//     backgroundColor: "#25D366",
//     color: "white",
//     border: "none",
//     borderRadius: "5px",
//     padding: "8px 12px",
//     cursor: "pointer",
//   };

//   return (
//     <>
//       <button style={buttonStyle} onClick={toggleChat}>
//         💬
//       </button>

//       <div style={chatBoxStyle}>
//         <div style={chatHeaderStyle} onClick={toggleChat}>
//           WhatsApp Chat
//         </div>
//         <div style={chatBodyStyle}>
//           <p>Hello! 👋 How can we help you?</p>
//         </div>
//         <div style={chatFooterStyle}>
//           <input
//             type="text"
//             placeholder="Type your message..."
//             style={inputStyle}
//           />
//           <button style={sendButtonStyle} onClick={openWhatsApp}>
//             Send
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default WhatsAppChatbot;


// import React from "react";

// const WhatsAppChatbot = () => {
//   const phoneNumber = "9703933115"; // Your WhatsApp number with country code
//   const message = "Hello! I need help."; // Prefilled message

//   const handleClick = () => {
//     window.open(
//       `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
//       "_blank"
//     );
//   };

//   const buttonStyle = {
//     position: "fixed",
//     bottom: "30px",
//     right: "30px",
//     zIndex: 1000,
//     width: "60px",
//     height: "60px",
//     backgroundColor: "#25D366", // WhatsApp green color
//     borderRadius: "50%",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     cursor: "pointer",
//     boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
//   };

//   return (
//     <div style={buttonStyle} onClick={handleClick}>
//       <svg
//         width="32"
//         height="32"
//         viewBox="0 0 24 24"
//         fill="white"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path d="M20.52 3.478a11.78 11.78 0 00-16.67 0 11.77 11.77 0 00-3.47 8.36c0 2.08.54 4.12 1.56 5.9L2 21l4.42-1.15a11.737 11.737 0 005.92 1.58h.01c3.14 0 6.09-1.23 8.3-3.45a11.78 11.78 0 000-16.68zm-8.04 18.47h-.01a9.404 9.404 0 01-4.78-1.31l-.34-.2-2.62.68.7-2.56-.22-.34a9.407 9.407 0 01-1.43-5.01 9.41 9.41 0 012.76-6.66 9.402 9.402 0 0113.27 0 9.405 9.405 0 010 13.28 9.354 9.354 0 01-6.32 2.81zm5.24-7.07c-.28-.14-1.64-.81-1.9-.9-.26-.1-.45-.14-.64.14-.18.28-.7.9-.86 1.08-.16.18-.31.2-.59.07-.28-.14-1.18-.44-2.24-1.38-.83-.74-1.39-1.64-1.55-1.92-.16-.28-.02-.43.12-.56.12-.12.28-.31.42-.46.14-.16.18-.28.28-.46.1-.18.04-.34-.02-.48-.06-.14-.64-1.54-.88-2.13-.23-.56-.47-.48-.64-.48-.16 0-.34-.02-.52-.02-.18 0-.48.07-.74.34-.26.28-1 1-1 2.44 0 1.44 1.02 2.83 1.16 3.02.14.18 2.02 3.06 4.88 4.29.68.29 1.21.46 1.62.59.68.22 1.3.19 1.79.11.55-.1 1.64-.67 1.87-1.31.23-.64.23-1.19.16-1.31-.07-.12-.26-.18-.54-.32z" />
//       </svg>
//     </div>
//   );
// };

// export default WhatsAppChatbot;



// import React from "react";
// import "./WhatsAppChatbot.css"; // We'll put styles here

// const WhatsAppChatbot = () => {
//   const phoneNumber = "9703933115";
//   const message = "Hello! I need help.";

//   const handleClick = () => {
//     window.open(
//       `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
//       "_blank"
//     );
//   };

//   return (
//     <div className="whatsapp-container" onClick={handleClick}>
//       <div className="whatsapp-bubble"></div>
//       <div className="whatsapp-icon">
//         <svg
//           width="28"
//           height="28"
//           viewBox="0 0 24 24"
//           fill="white"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path d="M20.52 3.478a11.78 11.78 0 00-16.67 0 11.77 11.77 0 00-3.47 8.36c0 2.08.54 4.12 1.56 5.9L2 21l4.42-1.15a11.737 11.737 0 005.92 1.58h.01c3.14 0 6.09-1.23 8.3-3.45a11.78 11.78 0 000-16.68zm-8.04 18.47h-.01a9.404 9.404 0 01-4.78-1.31l-.34-.2-2.62.68.7-2.56-.22-.34a9.407 9.407 0 01-1.43-5.01 9.41 9.41 0 012.76-6.66 9.402 9.402 0 0113.27 0 9.405 9.405 0 010 13.28 9.354 9.354 0 01-6.32 2.81zm5.24-7.07c-.28-.14-1.64-.81-1.9-.9-.26-.1-.45-.14-.64.14-.18.28-.7.9-.86 1.08-.16.18-.31.2-.59.07-.28-.14-1.18-.44-2.24-1.38-.83-.74-1.39-1.64-1.55-1.92-.16-.28-.02-.43.12-.56.12-.12.28-.31.42-.46.14-.16.18-.28.28-.46.1-.18.04-.34-.02-.48-.06-.14-.64-1.54-.88-2.13-.23-.56-.47-.48-.64-.48-.16 0-.34-.02-.52-.02-.18 0-.48.07-.74.34-.26.28-1 1-1 2.44 0 1.44 1.02 2.83 1.16 3.02.14.18 2.02 3.06 4.88 4.29.68.29 1.21.46 1.62.59.68.22 1.3.19 1.79.11.55-.1 1.64-.67 1.87-1.31.23-.64.23-1.19.16-1.31-.07-.12-.26-.18-.54-.32z" />
//         </svg>
//       </div>
//     </div>
//   );
// };

// export default WhatsAppChatbot;



// import React, { useState } from "react";
// import "./WhatsAppChatbot.css";

// const WhatsAppChatbot = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [message, setMessage] = useState("");

//   const phoneNumber = "9703933115"; // Your WhatsApp number with country code

//   const toggleChat = () => setIsOpen(!isOpen);

//   const sendMessage = () => {
//     if (message.trim() !== "") {
//       const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
//         message
//       )}`;
//       window.open(url, "_blank");
//       setMessage("");
//       setIsOpen(false);
//     }
//   };

//   return (
//     <>
//       {/* Floating button */}
//       <div className={`whatsapp-button ${isOpen ? "open" : ""}`} onClick={toggleChat}>
//         <svg
//           width="28"
//           height="28"
//           viewBox="0 0 24 24"
//           fill="white"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path d="M20.52 3.478a11.78 11.78 0 00-16.67 0 11.77 11.77 0 00-3.47 8.36c0 2.08.54 4.12 1.56 5.9L2 21l4.42-1.15a11.737 11.737 0 005.92 1.58h.01c3.14 0 6.09-1.23 8.3-3.45a11.78 11.78 0 000-16.68zm-8.04 18.47h-.01a9.404 9.404 0 01-4.78-1.31l-.34-.2-2.62.68.7-2.56-.22-.34a9.407 9.407 0 01-1.43-5.01 9.41 9.41 0 012.76-6.66 9.402 9.402 0 0113.27 0 9.405 9.405 0 010 13.28 9.354 9.354 0 01-6.32 2.81zm5.24-7.07c-.28-.14-1.64-.81-1.9-.9-.26-.1-.45-.14-.64.14-.18.28-.7.9-.86 1.08-.16.18-.31.2-.59.07-.28-.14-1.18-.44-2.24-1.38-.83-.74-1.39-1.64-1.55-1.92-.16-.28-.02-.43.12-.56.12-.12.28-.31.42-.46.14-.16.18-.28.28-.46.1-.18.04-.34-.02-.48-.06-.14-.64-1.54-.88-2.13-.23-.56-.47-.48-.64-.48-.16 0-.34-.02-.52-.02-.18 0-.48.07-.74.34-.26.28-1 1-1 2.44 0 1.44 1.02 2.83 1.16 3.02.14.18 2.02 3.06 4.88 4.29.68.29 1.21.46 1.62.59.68.22 1.3.19 1.79.11.55-.1 1.64-.67 1.87-1.31.23-.64.23-1.19.16-1.31-.07-.12-.26-.18-.54-.32z" />
//         </svg>
//       </div>

//       {/* Chat box */}
//       <div className={`whatsapp-chatbox ${isOpen ? "open" : ""}`}>
//         <div className="chat-header" onClick={toggleChat}>
//           WhatsApp Chat
//         </div>
//         <div className="chat-body">
//           <input
//             type="text"
//             placeholder="Type your message..."
//             value={message}
//             onChange={(e) => setMessage(e.target.value)}
//           />
//           <button onClick={sendMessage}>Send</button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default WhatsAppChatbot;


// import React, { useState } from "react";
// import "./WhatsAppChatbot.css";

// const WhatsAppChatbot = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [message, setMessage] = useState("");

//   const phoneNumber = "9703933115"; // Your WhatsApp number

//   const toggleChat = () => setIsOpen(!isOpen);

//   const sendMessage = () => {
//     if (message.trim() !== "") {
//       const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
//         message
//       )}`;
//       window.open(url, "_blank");
//       setMessage("");
//       setIsOpen(false);
//     }
//   };

//   return (
//     <>
//       {/* Floating button */}
//       <div className={`whatsapp-button ${isOpen ? "open" : ""}`} onClick={toggleChat}>
//         {/* Official WhatsApp SVG Logo */}
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 448 512"
//           width="28"
//           height="28"
//           fill="white"
//         >
//           <path d="M380.9 97.1C339-13.8 228.1-26.4 157.1 44.7c-63.9 63.9-54.6 161.1 22.6 222.2l-16.2 58.4 60.3-15.7c60.2 36.1 142.2 23.5 193.5-27.8 71-71 57.4-186.7-36.4-260.7zM317.6 302.4c-11.4 11.4-23.5 19.5-36.2 25.4-12.6 5.8-23.8 7.6-33.7 2.3-15.5-8-50.8-32-77.7-58.8s-50.8-62.2-58.8-77.7c-5.2-9.9-3.4-21.1 2.3-33.7 5.9-12.7 14-24.8 25.4-36.2s23.5-19.5 36.2-25.4c12.6-5.8 23.8-7.6 33.7-2.3 15.5 8 50.8 32 77.7 58.8s50.8 62.2 58.8 77.7c5.2 9.9 3.4 21.1-2.3 33.7z" />
//         </svg>
//       </div>

//       {/* Chat box */}
//       <div className={`whatsapp-chatbox ${isOpen ? "open" : ""}`}>
//         <div className="chat-header" onClick={toggleChat}>
//           WhatsApp Chat
//         </div>
//         <div className="chat-body">
//           <input
//             type="text"
//             placeholder="Type your message..."
//             value={message}
//             onChange={(e) => setMessage(e.target.value)}
//           />
//           <button onClick={sendMessage}>Send</button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default WhatsAppChatbot;


import React, { useState } from "react";
import WhatsAppIcon from "./m011t0447_f_social_sign_18sep22.jpg"; // Adjust the path
import "./WhatsAppChatbot.css";
import { useLocation } from "react-router-dom";

const WhatsAppChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");

  const phoneNumber = "9703933115";

  const toggleChat = () => setIsOpen(!isOpen);

  const sendMessage = () => {
    if (message.trim() !== "") {
      const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        message
      )}`;
      window.open(url, "_blank");
      setMessage("");
      setIsOpen(false);
    }
  };

    const location = useLocation();

  // Routes where chatbot should NOT be shown
  const hideOnRoutes = ["/adminlogin", "/admindashboard", "/cart", "/checkout", "/checkout/success", "/checkout/failure", ];

  if (hideOnRoutes.includes(location.pathname)) {
    return null;
  }

  return (
    <>
      {/* Floating button */}
      <div className={`whatsapp-button ${isOpen ? "open" : ""}`} onClick={toggleChat}>
        <img src={WhatsAppIcon} alt="WhatsApp" style={{ width: "45px", height: "45px",borderRadius:'50%' }} />
      </div>

      {/* Chat box */}
      <div className={`whatsapp-chatbox ${isOpen ? "open" : ""}`}>
        <div className="chat-header" onClick={toggleChat}>
          WhatsApp Chat
        </div>
        <div className="chat-body">
          <input
            type="text"
            placeholder="Type your message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <button onClick={sendMessage}>Send</button>
        </div>
      </div>
    </>
  );
};

export default WhatsAppChatbot;
